import {AppError} from '../../lib/appError';
export const DOCUMENT_CONFLICT='DOCUMENT_CONFLICT';
export function explainDocumentError(error:unknown):never {
 if(error instanceof AppError){
  if(error.code==='PGRST202')throw new AppError('Saving needs a site update. Your edits have not reached the server yet. Please keep this tab open and retry after the update.',error.code,error.cause);
  const message=(error.cause as {message?:string})?.message??'';
  if(message.includes('another session'))throw new AppError('This page was changed on another device or tab. Your edits are kept here; you can keep the latest version instead.', DOCUMENT_CONFLICT,error.cause);
  if(/fetch|network|load failed/i.test(message))throw new AppError('You appear to be offline. Your edits are kept here; retry when you’re connected.','NETWORK_ERROR',error.cause);
 }
 throw error;
}
